<div (mouseenter)="showTool()" (mouseleave)="hideTool()">
<div #toolbar class="toolbar" style="visibility:hidden">
<div class="tool-panel" >
    <div id="gmdm-toolbar">
        <div class="gmdm-shape selected" id="gmdm-hand" title="Stop drawing" (click)="changeDrawingMode('hand')"  [class.selected]="drawingMode === 'hand'|| !drawingMode">
            <div><img src="assets/images/drawing.png" /></div>
        </div>
        <div class="gmdm-shape" id="gmdm-marker" title="Add marker" (click)="changeDrawingMode('agmMarker')"  [class.selected]="drawingMode === 'agmMarker'">
            <div><img src="assets/images/drawing.png" /></div>
        </div>
        <div class="gmdm-shape" id="gmdm-polyline" title="Draw line" (click)="changeDrawingMode('polyline')"  [class.selected]="drawingMode === 'polyline'">
            <div><img src="assets/images/drawing.png" /></div>
        </div>
        <div class="gmdm-shape" id="gmdm-rectangle" title="Draw rectangle" (click)="changeDrawingMode('rectangle')"  [class.selected]="drawingMode === 'rectangle'">
            <div><img src="assets/images/drawing.png" /></div>
        </div>
        <div class="gmdm-shape" id="gmdm-circle" title="Draw circle" (click)="changeDrawingMode('circle')"  [class.selected]="drawingMode === 'circle'">
            <div><img src="assets/images/drawing.png" /></div>
        </div>
        <div class="gmdm-shape" id="gmdm-polygon" title="Draw polygon" (click)="changeDrawingMode('polygon')"  [class.selected]="drawingMode === 'polygon'">
            <div><img src="assets/images/drawing.png" /></div>
        </div> 
        
    </div>
    <label>Height : </label><input type="number" value="200" (change)="mapResize($event)"/>
	<button>Full Page</button>
	<button>Half Page</button>
</div>


</div>
</div>
<div id="mapContainer" class="d-flex flex-fill w-100 h-100">
 <!-- <agm-map id="test" class="googleMap w-100 h-100" controlSize=24 [latitude]="lat" [longitude]="lng"
            [zoom]="zoom" [disableDefaultUI]="false"
  [zoomControl]="false"
  (mapClick)="mapClicked($event)" (mapReady)="onMapReady($event)" 
           >
		   <agm-marker 
      *ngFor="let m of markers; let i = index"
      (markerClick)="clickedMarker(m.label, i)"
      [latitude]="m.lat"
      [longitude]="m.lng"
      [label]="m.label"
      [markerDraggable]="m.draggable"
      (dragEnd)="markerDragEnd(m, $event)">
      
    <agm-info-window>
      <strong>InfoWindow content</strong>
    </agm-info-window>
    
  </agm-marker>
  
  <agm-circle [latitude]="lat + 0.3" [longitude]="lng" 
      [radius]="5000"
      [fillColor]="'red'"
      [circleDraggable]="true"
      [editable]="true">
  </agm-circle>
   
</agm-map>-->
  
</div>

